var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useSegment } from '@ciceksepeti/cs-segment';
import { LiveChatWidget } from '@ciceksepeti/cs-live-chat-widget';
import '@ciceksepeti/cs-live-chat-widget/styles.css';
import Segment from '@constants/segment';
import { findLiveChatVisibleUrl } from '@helpers/live-chat-visibility';
import { useCommons } from '@hooks/use-commons';
import { useResponsive } from '@hooks/use-responsive';
import styles from './styles.module.scss';
var LiveChatWidgetWrapper = function (props) {
    var _a;
    var isSticky = props.isSticky;
    var _b = useState(undefined), stickySearchHeight = _b[0], setStickySearchHeight = _b[1];
    var variables = useCommons().variables;
    var ivrButton = variables.ivrButton;
    var _c = useResponsive(), isMobileDevice = _c.isMobileDevice, isTabletMobile = _c.isTabletMobile;
    var pathname = useLocation().pathname;
    var _d = ivrButton || {}, buttonLink = _d.buttonLink, buttonText = _d.buttonText, iconPath = _d.iconPath, desktopText = _d.desktopText, isLiveChatWidgetWrapperVisible = _d.isShow;
    var pageView = useSegment().pageView;
    var handleLiveChatButtonClick = function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pageView({
                            name: Segment.LIVE_CHAT,
                            properties: { referrer: window.location.href }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
        if (!window.top)
            return;
        var calculateWindowTopScreen = window.top.outerHeight / 2 + window.top.screenY - 600 / 2; // center in the window
        var calculateWindowLeftScreen = window.top.outerWidth / 2 + window.top.screenX - 600 / 2;
        window.open(buttonLink, 'Çiçeksepeti Asistan', "width=600 height=600 top=".concat(calculateWindowTopScreen, " left=").concat(calculateWindowLeftScreen));
    };
    var calculateStickyHeaderHeight = useCallback(function () {
        if (isSticky) {
            var searchWrapper = document.querySelector('.header__main__search-wrapper__mobile--sticky');
            if (searchWrapper) {
                var height = searchWrapper.clientHeight;
                // The total height was reduced by 2 pixels to prevent the thin line that rarely appears between sticky search and livechatbanner while scrolling.
                return "".concat(height - 2, "px");
            }
        }
        else {
            return undefined;
        }
    }, [isSticky]);
    useEffect(function () {
        var handleScroll = function () {
            var _stickyHeaderHeight = calculateStickyHeaderHeight();
            setStickySearchHeight(_stickyHeaderHeight);
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [calculateStickyHeaderHeight]);
    var livechatWidgetCn = classNames((_a = {},
        _a[styles.liveChatWidgetSticky] = isMobileDevice,
        _a[styles.liveChatWidgetStickyTabletMobile] = isTabletMobile,
        _a));
    return (_jsx(_Fragment, { children: isLiveChatWidgetWrapperVisible === true && findLiveChatVisibleUrl(pathname) ? (_jsx(LiveChatWidget, { style: { top: stickySearchHeight }, className: livechatWidgetCn, text: desktopText, buttonText: buttonText, iconProps: { iconName: "icon-".concat(iconPath ? iconPath : 'headset') }, onClick: handleLiveChatButtonClick })) : null }));
};
export default LiveChatWidgetWrapper;
